<template>
  <div>
    <v-layout
      row
      align-center
      mb-2
      @click="showMail"
    >
      <v-flex xs1>
        <v-icon
          size="14px"
          :color="statusColor(mail.status)"
        >brightness_1</v-icon>
      </v-flex>
      <v-flex 
        xs11
        class="ml-1"
      >
        <span>{{ mail.title }}</span>
      </v-flex>
      <v-flex 
        xs2
        class="text-xs-right body-1"
      >
        <span>{{ printDate(mail.created) }}</span>
      </v-flex>
    </v-layout>
    <v-divider class="mt-2 mb-2" />
  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'

export default {
  props: {
    mail: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      panel: null
    }
  },
  computed: {
    ...mapGetters('config', [
      'theme'
    ]),
    ...mapGetters('auth', [
      'user'
    ]),
    myMenuStyle () {
      return {
        backgroundColor: this.theme.bg_color
      }
    }
  },
  methods: {
    showMail () {
      this.$router.push({ name: 'mail', params: { id: this.mail.id }})
    },
    statusColor (status) {
      if (parseInt(status) === 0) {
        return 'red'
      }
      return 'grey'
    },
    printDate (d) {
      const d2 = moment(d)
      return d2.format('DD-M-YY')
    }
  }
}
</script>

<style scoped>
.title-row {
  margin-left: -24px;
}
</style>



// WEBPACK FOOTER //
// src/components/MailLine.vue